
define('template!companiesListDeleteView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class="mdi-action-delete cell-delete js-delete" title="' +
((__t = ( _.i18n('common.delete', null, 'Delete') )) == null ? '' : __t) +
'"></span>\n';

}
return __p
};});

